import React, {useContext, useRef, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import SystemContext from "../../../SystemContext";
import DataGrid from "../../../controls/DataGrid";
import { MaskedNumber } from '../../../controls';
import { useTheme } from '@material-ui/core';

const TripCosts = (props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const dialogTitle = "Actual Trip Costs - " + props.trip;

  const columns = [];
  const rows = [];
  const summaryRow = {"station": "Total"};

  const handleCellValueChanged = (params) => {
    const {node, column, newValue, oldValue} = params;

    if (newValue !== oldValue) {
      node.data[column?.colId] = newValue;
      node.data[column?.colId.replace('actual_', 'changed_')] = true;
    }
  }

  const numericColumnEditor = {
    component: "MaskedNumber",
    params: {
      isdatagrid: true,
//      value: props.value,
      decimalScale: 2,
      fixedDecimalScale: true,
      // onChange: props.onChange,
      style: {width:"100%", fontSize: "0.875rem", textAlign: "right"}
    }
  }

  // eslint-disable-next-line no-unused-vars
  const RenderNumber = (props) => {
    let numberStyle = {width:"100%", fontSize: "0.875rem", textAlign: "right"};
    if (props?.column?.colId.startsWith('actual_') && props?.data?.station !== 'Total') {
      if (!props.data[props?.column?.colId.replace('actual_', 'changed_')]){
        numberStyle = {width:"100%", fontSize: "0.875rem", textAlign: "right", color: 'rgba(0,0,0,0.5)'};
      }
    }
    const numberProps = {...props, style: numberStyle}
    return (
      <MaskedNumber {...numberProps} />
    )
  }

  const numericColumnRenderer = {
    component: "RenderNumber",
    params: {
      isdatagrid: true,
      displayType: "text",
//      value: props.value,
      decimalScale: 2,
      fixedDecimalScale: true,
      style: {width:"100%", fontSize: "0.875rem", textAlign: "right"}
    }
  }

  if (props.tripData) {
    const sageRoute = props.tripData.sageRoute;

    columns.push({field: "station", minWidth: 400, editable: false, type: undefined, pinned: true });
    sageRoute.forEach(station => {
      columns.push({headerName: station, pinned: true});
      columns.push({key: "budget_"+station, field: "budget_"+station, headerName: "Budget", minWidth: undefined, editable: false, type: "numericColumn", cellEditor: {...numericColumnEditor}, cellRenderer: {...numericColumnRenderer}, pinned: undefined, parent: station});
      columns.push({key: "actual_"+station, field: "actual_"+station, headerName: "Actual", minWidth: undefined, editable: undefined, type: "numericColumn", cellEditor: {...numericColumnEditor}, cellRenderer: {...numericColumnRenderer}, pinned: undefined, parent: station, onCellValueChanged: handleCellValueChanged});
    });
    columns.push({headerName: "Total", pinned: "right"});
    columns.push({field: "budget", headerName: "Budget", editable: false, type: "numericColumn", cellEditor: {...numericColumnEditor}, cellRenderer: {...numericColumnRenderer}, parent: "Total"});
    columns.push({field: "actual", headerName: "Actual", editable: false, type: "numericColumn", cellEditor: {...numericColumnEditor}, cellRenderer: {...numericColumnRenderer}, parent: "Total" });

    for (let value = 0; value < sageRoute.length; value++) {
      summaryRow["budget_"+sageRoute[value]] = 0;
      summaryRow["actual_"+sageRoute[value]] = 0;
    }
    summaryRow["budget"] = 0;
    summaryRow["actual"] = 0;

    const mappings = props.tripData.mappings;
    mappings.forEach(item => {
      const rowValues = {};
      rowValues["station"] = item.ledgerCode + " - " + item.ledgerName;
      const routeTotals = item.routeTotals;
      const routeTotalsActual = item.routeTotalsActual;
      const routeTotalsChanged = item.routeTotalsChanged;
      let rowTotal = 0;
      let rowTotalActual = 0;
      for (let value = 0; value < sageRoute.length; value++) {
        rowValues["budget_"+sageRoute[value]] = routeTotals[value];
        rowValues["actual_"+sageRoute[value]] = routeTotalsActual[value];
        rowValues["changed_"+sageRoute[value]] = routeTotalsChanged[value];
        summaryRow["budget_"+sageRoute[value]] += routeTotals[value]||false;
        summaryRow["actual_"+sageRoute[value]] += routeTotalsActual[value];
        rowTotal += routeTotals[value];
        rowTotalActual += routeTotalsActual[value];
      }
      rowValues["budget"] = rowTotal;
      rowValues["actual"] = rowTotalActual;
      summaryRow["budget"] += rowTotal;
      summaryRow["actual"] += rowTotalActual;
      rows.push(rowValues);
    })
  }

  function handleClose() {
    props.onChange();
  }

  function handleUpdate() {
    const rows = dataGridRef.current.getAllGridRows();

    if (props.tripData) {
      const sageRoute = props.tripData.sageRoute;
      const tripActualCosts = {
        "tripNo": props.tripData.tripNo,
        "route": props.tripData.route,
        "sageRoute": sageRoute,
      }
      const mappings = [];
      rows.forEach(row => {
        const actualRouteTotals = [];
        sageRoute.forEach(airport => {
          actualRouteTotals.push(null);
        })
        const ledgerCode = row.station.substr(0, row.station.indexOf(" -"));

        Object.keys(row).forEach(function (key) {
          if (key.startsWith("actual_")) {
            const changeKey = key.replace('actual_', 'changed_');
            if (row[changeKey]) {
              const airportPosition = key.indexOf("_") + 1;
              const sageAirport = key.substr(airportPosition, key.length - airportPosition);
              actualRouteTotals[sageRoute.indexOf(sageAirport)] = row[key];
            }
          }
        });

        mappings.push({
          ledgerCode,
          actualRouteTotals
        })
      })

      tripActualCosts["mappings"] = mappings;

      props.onChange(tripActualCosts);
    }
    else
      props.onChange(null);
  }

  const dataGridRef = useRef();
  return (
    <div id={"TripCosts"}>
      <Dialog open={props.open}
              onClose={handleClose}
              aria-labelledby="form-dialog-title"
              disableBackdropClick={true}
              maxWidth={"xl"}
              fullWidth={true}
      >
        <DialogTitle id="form-dialog-title">
          <div style={{clear: "both", backgroundColor:theme.palette.primary.main, padding:"10px"}}>
          {dialogTitle}
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please enter the required information in the grid fields below. Budget values are from the trip costing.
          </DialogContentText>
          <DataGrid
            ref={dataGridRef}
            columns={columns}
            rows={rows}
            summaryRow={summaryRow}
            components={{RenderNumber}}
          >
          </DataGrid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleUpdate} color="primary">
            Update Costs
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default TripCosts;
